import dateTimeFormatter from '../../../components/valueFormatter/dateTimeFormatter';
import organizationNameValueGetter from '../../../components/valueGetter/organization-base/organizationNameValueGetter';
import steelMakerFilterValueGetter from '../../../components/filterValueGetter/steelMakerFilterValueGetter';
import businessTypeFilterValueGetter from '../../../components/filterValueGetter/businessTypeFilterValueGetter';
import steelCategoryFilterValueGetter from '../../../components/filterValueGetter/steelCategoryFilterValueGetter';
import conditionStatusFilterValueGetter from '../../../components/filterValueGetter/conditionStatusFilterValueGetter';
import dateFilterComparator from '../../../utils/ag-grid/dateFilterComparator';
import type { ColDef } from 'ag-grid-community';
import type { TFunction } from 'i18next';

const useColdefManageApproval = (t: TFunction<'translation', undefined>) => {
  const colDefs: ColDef[] = [
    {
      colId: 'organizationName',
      headerName: t('organizationBase.organizationBase'),
      headerTooltip: t('organizationBase.organizationBase'),
      valueGetter: organizationNameValueGetter,
    },
    {
      field: 'steelMaker',
      headerName: t('steelMaker'),
      headerTooltip: t('steelMaker'),
      cellRenderer: 'steelMakerCellRenderer',
      filterValueGetter: steelMakerFilterValueGetter,
      minWidth: 180,
      maxWidth: 180,
    },
    {
      field: 'businessType',
      headerName: t('businessType'),
      headerTooltip: t('businessType'),
      cellRenderer: 'businessTypeCellRenderer',
      filterValueGetter: businessTypeFilterValueGetter,
      minWidth: 75,
      maxWidth: 75,
    },
    {
      field: 'steelCategory',
      headerName: t('steelCategory'),
      headerTooltip: t('steelCategory'),
      cellRenderer: 'steelCategoryCellRenderer',
      filterValueGetter: steelCategoryFilterValueGetter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'applicantName',
      headerName: t('approval.grid.requestor'),
      headerTooltip: t('approval.grid.requestor'),
    },
    {
      field: 'approverName',
      headerName: t('approval.grid.approver'),
      headerTooltip: t('approval.grid.approver'),
    },
    {
      field: 'requestDate',
      headerName: t('approval.grid.date'),
      headerTooltip: t('approval.grid.date'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateTimeFormatter,
    },
    {
      field: 'conditionStatus',
      headerName: t('approval.grid.status'),
      headerTooltip: t('approval.grid.status'),
      cellRenderer: 'conditionStatusRenderer',
      filterValueGetter: conditionStatusFilterValueGetter,
    },
  ];

  return colDefs;
};

export default useColdefManageApproval;
